import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ALERT_TYPE } from 'src/app/constants';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Blacklist } from 'src/model/blacklist';
import { BlacklistService } from 'src/services/blacklist.service';
import { SharedService } from '../../Shared/shared-service.service';
import { EditBlacklistComponent } from '../edit-blacklist/edit-blacklist.component';

@Component({
    selector: 'app-blacklist-customer-list',
    templateUrl: './blacklist-customer-list.component.html',
    styleUrls: ['./blacklist-customer-list.component.scss'],
    standalone: false
})
export class BlacklistCustomerListComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private blacklistService = inject(BlacklistService);

  displayedColumns: string[];
  dataSource = new MatTableDataSource();
  innerWidth: any;
  disabledSubmit = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  blacklistCustList: Blacklist[] = [];

  ngOnInit(): void {
    if (this.sharedService.isBossAccount() || this.sharedService.isAdmin())
      this.displayedColumns = ['Name', 'ICNumber', 'OtherID', 'Remark', 'Status', 'CreatedBy', 'CreatedOn', 'ReleasedBy', 'Action'];
    else
      this.displayedColumns = ['Name', 'ICNumber', 'OtherID', 'Status'];

    this.getAllBlacklistRecords();
  }

  async getAllBlacklistRecords() {
    this.blacklistCustList = await this.blacklistService.getAllBlacklist();
    this.blacklistCustList.sort((a, b) => (new Date(a.CreatedOn) > new Date(b.CreatedOn)) ? -1 : 1);

    //make customer list as the datasource
    this.dataSource = new MatTableDataSource(this.blacklistCustList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editBlacklistCustomer(record: Blacklist) {
    const modalRef = this.sharedService.openModal(EditBlacklistComponent);
    modalRef.componentInstance.blacklist = record;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  confirmationBeforeAction(msg: string): Promise<boolean> {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = msg;
    return modalRef.result.then((confirm) => {
      return confirm;
    });
  }

  // confirmBeforeReleaseCustomer(blacklist: Blacklist) {
  //   const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
  //   modalRef.componentInstance.message = "Confirm to release this customer: " + blacklist.Name + "?";
  //   //get confirmation
  //   modalRef.componentInstance.passEntry.subscribe((entry) => {
  //     var confirmation = entry;

  //     if (confirmation == true)
  //       this.releaseCustomer(blacklist.ID);
  //   });
  // }

  async releaseCustomer(blacklist: Blacklist) {
    const confirm = await this.confirmationBeforeAction(`Confirm to release this customer: ${blacklist.Name}?`);
    if (confirm) {
      const b = await this.blacklistService.getPatchReleaseCustomer(blacklist.ID);
      this.sharedService.openAlert("Successfully release customer: " + b.Name, ALERT_TYPE.SUCCESS);
      window.location.reload();
    }
  }


  uploadFileModal(blacklist: Blacklist) {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.blacklistId = blacklist.ID;
    modalRef.componentInstance.isBlacklistDocument = true


    modalRef.componentInstance.passEntry.subscribe(() => {

      window.location.reload();
    });

    // modalRef.result.then(() => {
    //   //detect changes
    //   this.cdr.detectChanges();
    // })
  }


  async viewFiles(blacklist: Blacklist) {
    const files = await this.blacklistService.getBlacklistAllFiles(blacklist.ID);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
  }

  async unreleaseCustomer(blacklist: Blacklist) {
    // Wait for API
    // const confirm = await this.confirmationBeforeAction(`Confirm to unrelease this customer: ${blacklist.Name}?`);
    // if (confirm) {
    // TODO: unrelease customer
    // }
  }
}
